import { RefObject, useEffect, useRef, useState } from "react"

const IS_SERVER = typeof window === 'undefined'

const useHover = (element: RefObject<Element | null>) => {
  const controllerRef = useRef<AbortController | null>(null)
  const [target, setTarget] = useState<Element | null>(null)
  const [hovered, setHovered] = useState(false)

  useEffect(() => {
    if (IS_SERVER) return

    setTarget(element.current)
  }, [element])

  useEffect(() => {
    if (IS_SERVER) return

    const controller = controllerRef.current
    if (controller && controller.signal.aborted === false) {
      /** Do not leave lingering listeners */
      controller.abort()
    }

    if (target) {
      const controller = new AbortController()

      const handleMouseOver = () => setHovered(true)
      const handleMouseOut = () => setHovered(false)

      target.addEventListener('mouseover', handleMouseOver, { signal: controller.signal })
      target.addEventListener('mouseout', handleMouseOut, { signal: controller.signal })

      controllerRef.current = controller

      return () => {
        controller.abort()
      }
    }
  }, [target])

  return [hovered, setTarget] as const
}

export default useHover
export { useHover } // Exporting useHover for named import
